export const basePath = "/";

export const calibrations = `${basePath}air-quality-monitoring/calibrations/`;
export const airQualityMonitoring = `${basePath}air-quality-monitoring/`;
export const _800callLogs = `${basePath}800-call-logs/`;
export const tracksideMonitoring = `${basePath}tsm/`;
export const tsmTopFive = `${tracksideMonitoring}:location_id/mines/:period`;
export const tsmAll = `${tracksideMonitoring}:location_id/:period`;
